import { render, staticRenderFns } from "./declareToday.vue?vue&type=template&id=ad78f286&scoped=true"
import script from "./declareToday.vue?vue&type=script&lang=js"
export * from "./declareToday.vue?vue&type=script&lang=js"
import style0 from "./declareToday.vue?vue&type=style&index=0&id=ad78f286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad78f286",
  null
  
)

export default component.exports